module.exports = __webpack_public_path__ + "img/icon-arrow-descending.b3cb651a.svg";